import styled from '@emotion/styled'
import { themeColor } from 'utils/styles'

const withStyle = (Component) =>
  styled(Component)(
    () => `
  
    .chec-popconfirm.cancel-primary .ant-popover-buttons .ant-btn:not(.ant-btn-danger):not(.ant-btn-primary):not(.ant-btn-secondary) {
      color: ${themeColor('whitePrimary')};
      background: ${themeColor('bluePrimary')};
      border: 1px solid ${themeColor('bluePrimary')}; 
    }
    .chec-popconfirm.cancel-primary .ant-popover-buttons .ant-btn:hover:not(.ant-btn-danger):not(.ant-btn-primary):not(.ant-btn-secondary) {
      background: ${themeColor('blueAccent')};
      color: ${themeColor('whitePrimary')};
      border: 1px solid ${themeColor('blueAccent')};
    }
  
    .chec-popconfirm .ant-popover-buttons {
      display: flex;
      flex-direction: row-reverse; 
    }
  
    .chec-popconfirm .ant-popover-message > .anticon {
      color: ${themeColor('errorPrimary')}; 
    }
  
    .chec-popconfirm .ant-btn-danger {
      color: ${themeColor('errorPrimary')};
      border: 1px solid ${themeColor('slateLight')};; 
    }
    .chec-popconfirm .ant-btn-danger:hover {
      background: ${themeColor('errorPrimary')};
      color: white;
      border: 1px solid ${themeColor('errorPrimary')}; 
    }
    `
  )

export default withStyle
